// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__89-lh","code":"styles_code__16sGz","footer":"styles_footer__2LU6x"};